import { ExclamationCircleTwoTone } from '@ant-design/icons';
import { Modal, Space, Spin, Typography } from 'antd';
import React, { useState } from 'react';
import { removeCredits } from '../../../services/learnerService';
import RemoveCreditsForm from './RemoveCreditsForm';

function CreditsRemove(props) {
  const initialValues = {
    reason: '',
    deductAmount: 1,
    email: props?.learner?.email,
    learner_id: props?.learner?.learnerId
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Request in Progress!' });

    const updatedValues = {
      email: props?.learner?.email,
      deductAmount: parseInt(values?.deductAmount * 100),
      learnerObjectId: props?.learner?._id,
      reason: values?.reason,
      promoType: values?.promoType
    };

    await removeCredits(updatedValues)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
        props.onSuccess();
      })
      .catch((error) => {
        alert('Getting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <Modal
      title={
        <Space>
          <ExclamationCircleTwoTone twoToneColor="#FE4255" />
          <Typography.Text>Remove Credits</Typography.Text>
        </Space>
      }
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <RemoveCreditsForm
          type="Remove"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
        />
      )}
    </Modal>
  );
}

export default CreditsRemove;
